import { render, staticRenderFns } from "./Headerpage.vue?vue&type=template&id=900e5044&scoped=true"
import script from "./Headerpage.vue?vue&type=script&lang=js"
export * from "./Headerpage.vue?vue&type=script&lang=js"
import style0 from "@/styles/headers.less?vue&type=style&index=0&id=900e5044&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900e5044",
  null
  
)

export default component.exports